module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fi":{"ppi-text-1":"Suunnitelman tiedot","ppi-text-2":"Tarkastele maksusuunnitelman tarkempia tietoja"},"se":{"ppi-text-1":"Betalningsplanens information","ppi-text-2":"Här kan du kontrollera betalningsplanens detaljuppgifter"},"en":{"ppi-text-1":"Payment plan information","ppi-text-2":"Here you can check the detailed information of the payment plan"}}')
  delete Component.options._Ctor
}
